import { ActionCreator, Action } from 'redux';
import { IContentBySearchState, StatusType, IPagination } from '..';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { SharePointService } from '../../services/SharePointService';
import { StatusChangedAction } from './StatusChangedAction';
import { IResult } from '../../data/data';
import { PaginationUpdatedAction } from './PaginationUpdatedAction';
import { ItemsUpdatedThunk } from './ItemsUpdatedThunk';

/**
 * User initiates a search
 *
 * note: ThunkAction type parameters:
 * R = Return Type of the inner function
 * S = State (from getState())
 * E = Extra parameter
 * A = Action
 *
 * @param query
 */
export const SearchThunk: ActionCreator<
  ThunkAction<void, IContentBySearchState, void, Action>
> = (restart: boolean, next: boolean) => {
  return (
    dispatch: ThunkDispatch<IContentBySearchState, void, Action>,
    getState: () => IContentBySearchState
  ): void => {
    const { query, pagination, env } = getState();
    let page = restart ? 1 : next ? pagination.page + 1 : pagination.page - 1;
    dispatch(StatusChangedAction({ type: StatusType.FETCHING }));
    SharePointService.fetch(env, query, page)
      .then((searchResult: IResult[]) => {
        dispatch(ItemsUpdatedThunk(searchResult));
        dispatch(
          PaginationUpdatedAction({
            page: page,
            hasNextPage: searchResult.length == parseInt(env.props.pageSize),
            hasPreviousPage: page > 1
          })
        );
      })
      .catch((error: any) => {
        let errorMessage =
          'Unknown error occured. Please try and refresh the page. If the issue persists, please contact your system administrator.';
        if ('response' in error && 'status' in error.response) {
          if (error.response.status == 401) {
            errorMessage =
              'Your session has expired. Please refresh the page. If the issue persists, please contact your system administrator.';
          }
        } else if ('request' in error && 'status' in error.request) {
          if (error.request.status == 401) {
            errorMessage =
              'Your session has expired. Please refresh the page. If the issue persists, please contact your system administrator.';
          }
        }
        dispatch(
          StatusChangedAction({
            type: StatusType.ERROR,
            statusMessage: errorMessage
          })
        );
      });
  };
};
